















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'UserManage'
})
export default class extends Vue {
  showNav = true
}
